import React, { useState } from "react";
import CustomBadges from "./CustomBadges";
import CustomTooltip from "./Filters/CustomTooltip";
import { useNavigate } from "react-router-dom";

const VQALibraryCard = ({
  type,
  services,
  imageUrl,
  name,
  documentType,
  report // Accept the report prop here
}) => {
  const [show, setShow] = useState(false);
  const providerNameTrim = name?.length > 50 ? name.slice(0, 30) + "..." : name;
  const navigate = useNavigate();

  return (
    <div
      className="w-72 rounded-2xl bg-white border h-60 cursor-pointer"
      
    >
      <div
        className={`w-full h-20 rounded-t-2xl flex justify-center items-center ${
          !imageUrl ? "bg-gray-100" : ""
        }`}
      >
        {imageUrl ? (
          <img
            src={imageUrl}
            alt="Card Image"
            className="w-40 h-16 object-contain pt-2.5"
            title={name}
          />
        ) : (
          <div className="text-custom-light-grey font-semibold text-center px-4">
            {name?.length > 30 ? (
              <CustomTooltip sliceLength={50} cutOffAfter={30}>
                {providerNameTrim}
              </CustomTooltip>
            ) : (
              name
            )}
          </div>
        )}
      </div>

      <div className="px-4 pb-3 flex flex-col divide-y divide-gray-100">
        <div className="py-2">
          <div className="flex items-center justify-between">
            <dd className="text-custom-dark-grey text-sm h-10"><strong>{name}: {report}</strong></dd> {/* Display report here */}
          </div>
        </div>

        <div className="pt-1">
          <div className="flex justify-center  border-b flex-wrap py-2 h-10 pb-3">
            <CustomBadges services={services} isProviderDetail={true} />
          </div>
          <div className="flex justify-center items-center pb-2 mt-2">
            <dd
              className="inline-flex cursor-default items-center gap-x-3 rounded-md text-white py-1 px-2 text-sm font-semibold shadow-sm w-40"
              style={{
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#AB54DB",
              }}
            >
              <p className="flex-1 text-center">View Info</p>
            </dd>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VQALibraryCard;
